import { render } from "./DashboardLeadTime.vue?vue&type=template&id=db240c8a&scoped=true&ts=true"
import script from "./DashboardLeadTime.vue?vue&type=script&lang=ts"
export * from "./DashboardLeadTime.vue?vue&type=script&lang=ts"

import "./DashboardLeadTime.vue?vue&type=style&index=0&id=db240c8a&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db240c8a"]])

export default __exports__